import axios from "axios";
import { 
    APPROVE_REQUEST,
    DELETE_REQUEST,
    DENY_REQUEST,
    SET_LOADER,
    CATCH_ERROR,
    FETCH_ACCESS_REQUESTS,
    FETCH_PENDING_REQUESTS,
    FETCH_ACCESS_SITES,
    RESET_ACTION
} from "./type";
import { API_PATHS } from "./constant";

export const setLoader = (loader) => (dispatch) => {
    dispatch({ type: SET_LOADER, payload: loader })
}

export const resetAction = () => (dispatch) => {
  dispatch({ type: RESET_ACTION, payload: {} });
};

export const fetchSitesForAccess = () => {
  return (dispatch) => {
    axios
      .get(`${API_PATHS.ACCESS_SITES_API}`)
      .then((res) => {
        dispatch({ type: FETCH_ACCESS_SITES, payload: { data: res.data } });
      })
      .catch((err) => {
        dispatch({ type: CATCH_ERROR, payload: { data: err.response?.data?.error, status: false } });
      });
  };
};
export const fetchAccessRequest = (currentPage, pageSize, searchTxt, approveStatus, id, site) => {
  const addId = id ? `&id=${id}` : "";
  const addSite = site ? `&site=${encodeURIComponent(site)}` : "";
  const addFilter = approveStatus ? `&filterBy=${encodeURIComponent(approveStatus.toUpperCase())}` : "";
  const addSearch = searchTxt ? `&searchText=${encodeURIComponent(searchTxt)}` : "";
  return (dispatch) => {
    axios
      .get(`${API_PATHS.ACCESS_PAGE_API}?page=${currentPage}&size=${pageSize}${addSearch}${addFilter}${addId}${addSite}`)
      .then((res) => {
        dispatch({ type: FETCH_ACCESS_REQUESTS, payload: { data: res.data }});
      })
      .catch((err) => {
        dispatch({ type: CATCH_ERROR, payload: { data: err.response?.data?.error, status: false }});
      })
  }
}

export const fetchPendingRequests = () => {
  return (dispatch) => {
    axios
      .get(`${API_PATHS.PENDING_REQUESTS}`)
      .then((res) => {
        dispatch({ type: FETCH_PENDING_REQUESTS, payload: { data: res.data }});
      })
      .catch((err) => {
        dispatch({ type: CATCH_ERROR, payload: { data: err.response?.data?.error, status: false }});
      })
  }
}

export const approveRequest = (id, gatewayName, type, isTierChange = false) => {
    return (dispatch) => {
      const tierChangeParam = isTierChange ? `&isTierChange=true` : '';
      axios
        .post(`${API_PATHS.ACCESS_PAGE_API}/${id}/${type}?gateway=${gatewayName}${tierChangeParam}`)
        .then((res) => {
          dispatch({
            type: APPROVE_REQUEST,
            payload: {
              data: res.data,
            },
          })
        })
        .catch((err) => {
          dispatch({
            type: CATCH_ERROR,
            payload: {
              data: err.response?.data?.error,
              status: false
            },
          })
        })
    }
  }

  export const denyRequest = (id, gatewayName, type, reason = "", isTierChange = false) => {
    return (dispatch) => {
      const body = { reason };
      if (isTierChange) {
        body.isTierChange = true;
      }
      axios
      .post(`${API_PATHS.ACCESS_PAGE_API}/${id}/${type}?gateway=${gatewayName}`, body)
        .then((res) => {
          dispatch({
            type: DENY_REQUEST,
            payload: {
              data: res.data,
            },
          })
        })
        .catch((err) => {
          dispatch({
            type: CATCH_ERROR,
            payload: {
              data: err.response?.data?.error,
              status: false
            },
          })
        })
    }
  }

export const bulkApproveRequests = (ids, gatewayName) => {
  return (dispatch) => {
    const accessRequestIds = (ids || []).map((id) => String(id));
    axios
      .post(`${API_PATHS.ACCESS_PAGE_API}/bulk-approve?gateway=${encodeURIComponent(gatewayName)}`, {
        accessRequestIds,
      })
      .then((res) => {
        const { status, message } = res.data;
        if (status === "FAILED") {
          dispatch({ type: CATCH_ERROR, payload: { data: message, status: false } });
        } else {
          dispatch({
            type: APPROVE_REQUEST,
            payload: { data: { status, message, bulk: true } },
          });
        }
      })
      .catch((err) => {
        dispatch({ type: CATCH_ERROR, payload: { data: err.response?.data?.message || "Bulk approve failed", status: false } });
      });
  };
}

export const bulkDenyRequests = (ids, reason = "", gatewayName) => {
  return (dispatch) => {
    const accessRequestIds = (ids || []).map((id) => String(id));
    axios
      .post(`${API_PATHS.ACCESS_PAGE_API}/bulk-reject?gateway=${encodeURIComponent(gatewayName)}`, {
        accessRequestIds,
        reason,
      })
      .then((res) => {
        const { status, message } = res.data;
        if (status === "FAILED") {
          dispatch({ type: CATCH_ERROR, payload: { data: message, status: false } });
        } else {
          dispatch({
            type: DENY_REQUEST,
            payload: { data: { status, message, bulk: true } },
          });
        }
      })
      .catch((err) => {
        dispatch({ type: CATCH_ERROR, payload: { data: err.response?.data?.message || "Bulk deny failed", status: false } });
      });
  };
}

export const deleteRequest = (id, gatewayName) => {
    return (dispatch) => {
      axios
        .delete(`${API_PATHS.ACCESS_PAGE_API}/${id}/delete?gateway=${gatewayName}`)
        .then((res) => {
          dispatch({
            type: DELETE_REQUEST,
            payload: {
              data: res.data,
              status: false
            },
          })
        })
        .catch((err) => {
          dispatch({
            type: CATCH_ERROR,
            payload: {
              data: err.response?.data?.error || err.message || "Delete request failed",
              status: false
            },
          })
        })
    }
  }